export default __webpack_public_path__ + "static/TCP_SUS_IMPACT_2023-5d3f50b1f96c8ef071586695a889e39d.pdf";